var _path, _g, _g2, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconMaintain(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 43,
    viewBox: "0 0 33 43",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.3903 28.5299L29.4234 28.504L29.4535 28.4745C30.9223 27.0351 31.75 25.0651 31.75 23.0086V9.11169C31.75 6.95641 30.8296 4.90371 29.2203 3.47001C27.6153 2.0401 25.5407 1.25 23.3912 1.25H8.48474C6.51833 1.25 4.64198 2.07438 3.31189 3.5227C1.98582 4.96664 1.25 6.8557 1.25 8.81617V22.3954C1.25 24.5528 2.05974 26.6316 3.51903 28.2206C4.98202 29.8137 7.07325 30.6802 9.23421 30.5889L25.6862 29.8934C27.0329 29.8364 28.328 29.3597 29.3903 28.5299Z",
    fill: "url(#paint0_linear_252_9991)",
    stroke: "url(#paint1_linear_252_9991)",
    strokeWidth: 1.5
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_252_9991)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.968 26.7H20.4545L18.697 26.811L20.0151 26.7555L21.3333 26.7H16.167H23.968L19.5175 26.7L19.6066 26.7H19.1364H16.167H9.91081C6.51788 26.7 3.75757 29.5339 3.75757 33.0174C3.75757 36.5008 6.51788 39.3347 9.91081 39.3347C10.997 39.3347 12.0649 39.0399 12.9992 38.482C13.7751 38.0188 14.4453 37.3838 14.9583 36.6298H18.9204C19.4335 37.3838 20.1037 38.0188 20.8796 38.482C21.8139 39.0399 22.8818 39.3347 23.968 39.3347C27.3609 39.3347 30.1212 36.5008 30.1212 33.0174C30.1212 29.5339 27.3609 26.7 23.968 26.7ZM23.968 37.7487C22.3512 37.7487 20.8325 36.8608 20.0044 35.4315L19.7799 35.0439H14.0989L13.8743 35.4315C13.0463 36.8608 15.7157 34.4799 14.0989 34.4799C11.5577 34.4799 5.30226 33.0174 5.30226 33.0174C5.30226 33.0174 12.6406 35.4315 15.1818 35.4315L19.7799 36.2844L24.8485 38.991L27.9242 36.2844C30.4654 36.2844 28.5765 30.4084 28.5765 33.0174C28.5765 35.6263 26.5092 37.7487 23.968 37.7487Z",
    fill: "url(#paint2_linear_252_9991)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.5717 32.2781V30.8155H9.02691V32.2781H7.60229V33.864H9.02691V35.3266H10.5717V33.864H11.9963V32.2781H10.5717Z",
    fill: "url(#paint3_linear_252_9991)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.8938 30.255L21.3361 32.8809L22.4284 34.0023L24.9861 31.3764L23.8938 30.255Z",
    fill: "url(#paint4_linear_252_9991)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.8159 32.2287L23.2582 34.8547L24.3505 35.9761L26.9082 33.3501L25.8159 32.2287Z",
    fill: "url(#paint5_linear_252_9991)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.3384 32.2781H14.7937V33.864H16.3384V32.2781Z",
    fill: "url(#paint6_linear_252_9991)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.085 32.2781H17.5403V33.864H19.085V32.2781Z",
    fill: "url(#paint7_linear_252_9991)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.1361 29.4587H14.7423V31.0447H19.1361V29.4587Z",
    fill: "url(#paint8_linear_252_9991)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_252_9991)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25.3137 13.9677V15.7191C25.3135 15.9513 25.2235 16.1739 25.0636 16.338C24.9037 16.5022 24.6869 16.5945 24.4608 16.5948H23.2451C23.0925 17.1902 22.8617 17.7616 22.559 18.2931L23.4196 19.1792C23.5784 19.3436 23.6674 19.5657 23.6674 19.7971C23.6673 20.0286 23.5781 20.2507 23.4193 20.4149L22.211 21.6553C22.0489 21.8145 21.8333 21.9033 21.609 21.9033C21.3847 21.9033 21.1691 21.8145 21.0071 21.6553L20.1444 20.7721C19.6267 21.0829 19.0702 21.3198 18.4902 21.4765V22.7246C18.4899 22.9568 18.4 23.1793 18.2401 23.3435C18.0802 23.5077 17.8634 23.6 17.6372 23.6003H15.9314C15.7052 23.6 15.4884 23.5077 15.3285 23.3435C15.1686 23.1793 15.0787 22.9568 15.0784 22.7246V21.4765C14.7261 21.3807 14.382 21.2556 14.0496 21.1023C14.0079 21.0827 13.9714 21.053 13.9432 21.0158C13.915 20.9787 13.896 20.9351 13.8876 20.8888C13.8793 20.8425 13.8819 20.7948 13.8953 20.7497C13.9087 20.7046 13.9324 20.6635 13.9645 20.6299L15.1728 19.3863C15.2091 19.349 15.2546 19.3225 15.3044 19.3096C15.3542 19.2967 15.4065 19.2978 15.4557 19.3129C15.8867 19.4458 16.3343 19.5135 16.7843 19.5137C17.684 19.5137 18.5635 19.2398 19.3116 18.7266C20.0597 18.2135 20.6427 17.4841 20.987 16.6307C21.3313 15.7773 21.4214 14.8382 21.2459 13.9323C21.0704 13.0263 20.6371 12.1941 20.0009 11.541C19.3647 10.8878 18.5542 10.443 17.6718 10.2628C16.7893 10.0826 15.8747 10.1751 15.0435 10.5286C14.2122 10.8821 13.5018 11.4807 13.0019 12.2487C12.5021 13.0167 12.2353 13.9197 12.2353 14.8434C12.2357 15.3045 12.3016 15.7631 12.4309 16.2047C12.4456 16.2551 12.4468 16.3088 12.4342 16.3598C12.4216 16.4109 12.3958 16.4575 12.3595 16.4947L11.1483 17.7381C11.1155 17.7712 11.0755 17.7957 11.0316 17.8095C10.9877 17.8233 10.9412 17.826 10.896 17.8175C10.8508 17.8089 10.8083 17.7894 10.7721 17.7604C10.7358 17.7314 10.7069 17.6939 10.6878 17.6511C10.5387 17.3097 10.4169 16.9564 10.3235 16.5948H9.10782C8.88169 16.5945 8.66488 16.5022 8.50498 16.338C8.34507 16.1739 8.25513 15.9513 8.25488 15.7191V13.9677C8.25513 13.7356 8.34507 13.513 8.50498 13.3488C8.66488 13.1846 8.88169 13.0923 9.10782 13.092H10.3235C10.4761 12.4965 10.7069 11.9251 11.0096 11.3935L10.149 10.5076C9.99024 10.3433 9.90117 10.1212 9.90122 9.88968C9.90127 9.65821 9.99044 9.43614 10.1493 9.27189L11.3576 8.03147C11.5197 7.87231 11.7353 7.78348 11.9596 7.78348C12.1838 7.78348 12.3995 7.87231 12.5615 8.03147L13.4242 8.91472C13.9419 8.60395 14.4984 8.36698 15.0784 8.21034V6.96223C15.0787 6.73007 15.1686 6.50748 15.3285 6.34331C15.4884 6.17914 15.7052 6.0868 15.9314 6.08655H17.6372C17.8634 6.0868 18.0802 6.17914 18.2401 6.34331C18.4 6.50748 18.4899 6.73007 18.4902 6.96223V8.21034C19.0702 8.36698 19.6267 8.60395 20.1444 8.91472L21.0075 8.03119C21.1696 7.87219 21.3852 7.78349 21.6094 7.78355C21.8335 7.7836 22.0491 7.87241 22.2111 8.03148L23.4193 9.27203C23.5782 9.43634 23.6674 9.65849 23.6674 9.89003C23.6674 10.1216 23.5782 10.3437 23.4193 10.508L22.559 11.3935C22.8617 11.9251 23.0925 12.4965 23.2451 13.092H24.4608C24.6869 13.0923 24.9037 13.1846 25.0636 13.3488C25.2235 13.513 25.3135 13.7356 25.3137 13.9677ZM20.0229 13.3536C20.0071 13.3068 19.98 13.2649 19.9442 13.2318C19.9084 13.1986 19.865 13.1753 19.8181 13.1639C19.7711 13.1526 19.7221 13.1536 19.6757 13.1669C19.6292 13.1802 19.5868 13.2054 19.5523 13.24L18.2586 14.5683L17.3539 14.2586L17.0524 13.3298L18.3461 12.0016C18.3798 11.9662 18.4043 11.9226 18.4172 11.8749C18.4302 11.8272 18.4312 11.777 18.4202 11.7288C18.4091 11.6806 18.3864 11.636 18.3541 11.5992C18.3218 11.5625 18.281 11.5347 18.2354 11.5184C17.7485 11.3497 17.2261 11.3198 16.724 11.4319C16.2218 11.544 15.7587 11.794 15.3841 12.1552C15.0094 12.5163 14.7373 12.9751 14.5967 13.4825C14.4561 13.99 14.4523 14.5272 14.5857 15.0367L8.69621 21.0833C8.42962 21.357 8.27986 21.7282 8.27986 22.1152C8.27986 22.5023 8.42962 22.8735 8.69621 23.1472C8.96279 23.4209 9.32436 23.5746 9.70137 23.5746C10.0784 23.5746 10.4399 23.4209 10.7065 23.1472L16.596 17.1006C17.0923 17.2376 17.6155 17.2337 18.1098 17.0893C18.6041 16.945 19.051 16.6656 19.4027 16.281C19.7545 15.8963 19.998 15.4209 20.1072 14.9053C20.2164 14.3898 20.1873 13.8535 20.0229 13.3536Z",
    fill: "url(#paint9_linear_252_9991)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_252_9991",
    x1: 16.5,
    y1: 2,
    x2: 16.5225,
    y2: 29.9689,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D78E28"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F4D974"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_252_9991",
    x1: 16.5,
    y1: 2,
    x2: 16.5225,
    y2: 29.9689,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D78E28"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F4D974"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_252_9991",
    x1: 16.9394,
    y1: 26.7,
    x2: 16.9444,
    y2: 39.3347,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D78E28"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F4D974"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_252_9991",
    x1: 9.79929,
    y1: 35.3266,
    x2: 9.79929,
    y2: 30.8155,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0E1017"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#212224"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_252_9991",
    x1: 23.7072,
    y1: 32.6894,
    x2: 22.5862,
    y2: 31.5975,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0E1017"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#212224"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_252_9991",
    x1: 25.6293,
    y1: 34.6631,
    x2: 24.5083,
    y2: 33.5712,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0E1017"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#212224"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_252_9991",
    x1: 15.5661,
    y1: 33.864,
    x2: 15.5661,
    y2: 32.2781,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0E1017"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#212224"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_252_9991",
    x1: 18.3127,
    y1: 33.864,
    x2: 18.3127,
    y2: 32.2781,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0E1017"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#212224"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_252_9991",
    x1: 16.9392,
    y1: 31.0447,
    x2: 16.9392,
    y2: 29.4587,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0E1017"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#212224"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_252_9991",
    x1: 16.7843,
    y1: 23.6003,
    x2: 16.7843,
    y2: 6.08655,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0E1017"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#212224"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_252_9991"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 26.3636,
    height: 27.0667,
    fill: "white",
    transform: "translate(3.75757 15.5332)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_252_9991"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18.1961,
    height: 18.6813,
    fill: "white",
    transform: "translate(7.68628 5.50275)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMaintain);
export default __webpack_public_path__ + "static/media/icon_maintain.726ed23278d831f60d16ab3a059f1acb.svg";
export { ForwardRef as ReactComponent };